import React from "react"

const Logo = () => {
	return (
		<h1 className="w-full font-sans text-4xl font-medium text-center select-none logo">
			<span className="p-1 mr-1 text-white rounded bg-red">DEV</span>
			CHEATS
		</h1>
	)
}

export default Logo
